export default "__VITE_ASSET__RHol0TW1__"